module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-08-fefa0e52d8fd0d02a21cdcdc26596503.jpg";